export default __webpack_public_path__ + "static/media/people3full.fd418e8a.jpg";